import React from 'react';
import { PropTypes } from 'prop-types';
import { get } from 'lodash';
import formatDate from 'common/utils/Dates/formatDate';
import { AUTHORIZATION_STATUSES_TO_TEXT, AUTHORIZATION_STATUSES } from 'common/Status/authorizationConstants';
import TimelineEventDetails from 'common/Workqueue/TimelineEventDetails';
import BaseTimelineEvent from 'common/Workqueue/BaseTimelineEvent';

const ServiceAuthorizationStateEvent = ({ timelineEvent }) => {
  const additionalData = get(timelineEvent, 'additional_data');
  const eventChanges = get(timelineEvent, 'changes');

  const stateText = eventChanges.find((change) => change.field_name === 'state')?.to;
  const employeeName = stateText === AUTHORIZATION_STATUSES.void ?
    'System' : get(additionalData, 'employee_name');
  const reviewReason = get(additionalData, 'review_reason', '');
  const inReviewNote = eventChanges.find((change) => change.field_name === 'in_review_note')?.to;
  const assignedTo = get(additionalData, 'assigned_to', '');

  const STATE_TO_ICON = {
    [AUTHORIZATION_STATUSES.accepted]: 'IconCheckCircle',
    [AUTHORIZATION_STATUSES.autoAccepted]: 'IconCheckCircle',
    [AUTHORIZATION_STATUSES.deferred]: 'IconMinusCircle',
    [AUTHORIZATION_STATUSES.inReview]: 'IconFileText',
    [AUTHORIZATION_STATUSES.open]: 'IconPencil',
    [AUTHORIZATION_STATUSES.rejected]: 'IconCrossCircleV2',
    [AUTHORIZATION_STATUSES.void]: 'IconMinusCircle',
  };
  const icon = STATE_TO_ICON[stateText];
  let message;
  if (stateText === AUTHORIZATION_STATUSES.inReview) {
    message = `Placed In Review by ${employeeName}`;
  } else {
    message = `${AUTHORIZATION_STATUSES_TO_TEXT[stateText]} by ${employeeName}`;
  }
  const date = formatDate(timelineEvent.timestamp);
  const eventDetailItems = [
    { label: 'Review Reason', value: reviewReason },
    ...(inReviewNote ? [{ label: 'Notes', value: inReviewNote }] : []),
    ...(assignedTo ? [{ label: 'Assigned To', value: assignedTo }] : []),
  ];
  const eventDetails = <TimelineEventDetails eventItems={eventDetailItems} eventDate={date} />;

  const formattedTimelineEvent = {
    icon,
    message,
    date,
    ...((stateText === AUTHORIZATION_STATUSES.inReview) ? { eventDetails } : null),
  };

  return (
    <BaseTimelineEvent {...formattedTimelineEvent} />
  );
};

ServiceAuthorizationStateEvent.propTypes = {
  timelineEvent: PropTypes.object.isRequired,
};

export default ServiceAuthorizationStateEvent;
